import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption";
import videoPlayerEvents from "@/view/constants/videoPlayerEvents";
import { popoutContainerCss } from "@/view/SecondaryActions/SecondaryActions.style";
import useGetVideoConfig from "@/view/utils/useGetVideoConfig";
import usePresentModeContext from "@/view/utils/usePresentModeContext";
import useVideoEventBus from "@/view/utils/useVideoEventBus";

const propTypes = {
  contentId: PropTypes.string,
  content: PropTypes.object,
  handleToggleBannerMode: PropTypes.func,
  isMobile: PropTypes.bool,
};

const PresentOptions = ({
  contentId,
  content,
  handleToggleBannerMode,
  isMobile,
}) => {
  const { VIEW_PAGE_EVENT } = videoPlayerEvents;
  const { sendVideoPlayerEvent } = useVideoEventBus();
  const { setPresentModeWithoutQuiz, setIsPresentModeActive } =
    usePresentModeContext();

  const videoConfig = useGetVideoConfig(content?.data?.url);
  const videoHasQuiz = videoConfig?.annotations?.some(
    (annotation) => annotation?.type === "quiz",
  );

  const getEventProperties = (withQuiz) => {
    return {
      objectType: "Content",
      actionName: "Page View",
      streamProperties: {
        content_type: "interactivevideolink",
        description: `Turn Present Mode on ${withQuiz ? "with" : "without"} quiz included`,
        content_id: contentId,
      },
    };
  };

  const handleClick = (withQuiz) => {
    setIsPresentModeActive(true);
    handleToggleBannerMode();
    sendVideoPlayerEvent(VIEW_PAGE_EVENT.PRESENT_MODE_ACTIVE, {
      isPresentModeActive: true,
      isPresentModeActiveWithoutQuiz: !withQuiz,
    });
    !withQuiz && setPresentModeWithoutQuiz(true);
  };

  // Skip dropdown menu and present immediately if there is no quiz
  if (videoHasQuiz === false) {
    handleClick(false);
    return;
  }

  const popoutContents = (
    <>
      <ActionPopOutOption
        dataProps={{ "data-qa-selector": "present-with-quiz" }}
        eventProperties={getEventProperties(true)}
        onClick={() => handleClick(true)}
        title="With quiz"
      />
      <ActionPopOutOption
        dataProps={{ "data-qa-selector": "present-without-quiz" }}
        eventProperties={getEventProperties(false)}
        onClick={() => handleClick(false)}
        title="Without quiz"
      />
    </>
  );

  if (isMobile) return popoutContents;

  return <ul css={popoutContainerCss}>{popoutContents}</ul>;
};

PresentOptions.propTypes = propTypes;

export default PresentOptions;
